module.exports = __webpack_public_path__ + "static/media/company-four.c23a81e7.jpg";